import { gql } from "@apollo/client";
import { PRICE_ACCESSORY_FIELDS } from "./accessory";
import { PRICE_PIECE_FIELDS } from "./piece";

// --------------------------------------------------------- Pricing ---------------------------------------------------------
export const PRICING_CATALOG_FIELDS = gql`
${PRICE_PIECE_FIELDS}
${PRICE_ACCESSORY_FIELDS}
fragment PricingCatalogFields on PricingCatalog {
    currency
    pieces {
        ...PricePieceFields
    }
    accessories {
        ...PriceAccessoryFields
    }
  }`